<template>
  <!-- Page Content -->
  <div class="whole-page-long">
    <div class="navbar-div">
      <NavbarComponent :user="user" analysis="CREATEREPORT" />
    </div>

    <div class="row f-row justify-content-center h-100">
      <div class="col col-12 f-row">
        <div class="h-100 d-flex flex-column">
          <div class="row f-row mt-4">
            <div class="col col-12 text-center">
              {{ nameView }}
            </div>
          </div>

          <div
            class="row f-row mt-3 scrl80 text-center"
            v-if="reponseMessage != ''"
          >
            {{ reponseMessage }}
          </div>

          <div class="row f-row mt-3 scrl80" v-if="reponseMessage == ''">
            <div class="col col-4" style="padding-right: 5px;">
              <table class="table table-borderless table-profile-user">
                <tbody>
                  <tr>
                    <th scope="row" style="width:240px">Report Title:</th>
                    <td>
                      <input
                        type="text"
                        nanme="report_title"
                        id="report_title"
                        class="form-control"
                        v-model="dataReport.title"
                      />
                      <span style="color:red" v-if="ValidateTitle">{{
                        MessageTitle
                      }}</span>
                    </td>
                  </tr>
                  <tr>
                    <th scope="row" style="width:240px">Image Path:</th>
                    <td>
                      <input
                        type="text"
                        nanme="image_path"
                        id="image_path"
                        class="form-control"
                        v-model="dataReport.image"
                      />
                      <span style="color:red" v-if="ValidateImage">{{
                        MessageImage
                      }}</span>
                    </td>
                  </tr>
                  <tr>
                    <th scope="row" style="width:240px">Report Summary:</th>
                    <td>
                      <textarea
                        v-model="dataReport.summary"
                        placeholder="Summary report"
                        nanme="report_summary"
                        id="report_summary"
                        class="form-control"
                        style="overflow:scroll; resize:none"
                      >
                      </textarea>
                      <span style="color:red" v-if="ValidateSummary">{{
                        MessageSummary
                      }}</span>
                    </td>
                  </tr>
                  <tr>
                    <th scope="row" style="width:240px">Report Type:</th>
                    <td>
                      <select
                        name="report_type"
                        id="report_type"
                        v-model="dataReport.state"
                        class="form-control"
                      >
                        <option
                          v-for="(value, key) in liststate"
                          :key="key"
                          :value="value.id"
                          >{{ value.name }}</option
                        >
                      </select>
                      <span style="color:red" v-if="ValidateReportType">{{
                        MessageReportType
                      }}</span>
                    </td>
                  </tr>
                  <tr>
                    <th scope="row" style="width:240px">Tags:</th>
                    <td>
                      <select
                        name="tags_report"
                        id="tags_report"
                        v-model="tags"
                        class="form-control"
                      >
                        <option
                          v-for="(value, key) in listTags"
                          :key="key"
                          :value="value.id"
                          >{{ value.name }}</option
                        >
                      </select>
                      <br />
                      <button
                        class="btn btn-sm btn-markets"
                        style="width: 100px;"
                        @click="select"
                      >
                        Select
                      </button>
                    </td>
                  </tr>
                  <tr>
                    <th scope="row" style="width:240px">Selected Tags:</th>
                    <td>
                      <select
                        name="tags_selected_report"
                        id="tags_selected_report"
                        multiple="multiple"
                        v-model="dataReport.SelectTags"
                        class="form-control"
                      >
                        <option
                          v-for="(value, key) in listTagsSelected"
                          :key="key"
                          :value="value.id"
                          >{{ value.name }}</option
                        >
                      </select>
                      <br />
                      <button
                        class="btn btn-sm btn-markets"
                        style="width: 100px;"
                        @click="remove"
                      >
                        remove
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="col col-8">
              <div id="app">
                <!-- <img alt="Vue logo" src="../../assets/images/logo.png"> -->
                <editor
                  apiKey="bmbugc2sizrt68i5nbfv23jszcgya4qf84douquyqj02dm4a"
                  :init="{
                    height: 500,
                    menubar: false,
                    plugins: [
                      'advlist autolink lists link image charmap print preview anchor',
                      'searchreplace visualblocks code fullscreen',
                      'insertdatetime media table paste code help wordcount'
                    ],
                    toolbar:
                      'undo redo | formatselect | bold italic backcolor | \
                                            alignleft aligncenter alignright alignjustify | \
                                            bullist numlist outdent indent | removeformat | \
                                            fullscreen  preview save print | insertfile image media pageembed template link anchor codesample'
                  }"
                  v-model="dataReport.report"
                />
              </div>
            </div>
          </div>
          <div class="row f-row mt-3 scrl80" v-if="reponseMessage == ''">
            <button
              class="btn btn-sm btn-markets"
              style="width: 100px;"
              @click="saveReport(true)"
            >
              SAVE AND POST
            </button>
            <button
              class="btn btn-sm btn-markets"
              style="width: 100px;"
              @click="saveReport(false)"
            >
              SAVE DRAFTS
            </button>
            <button
              class="btn btn-sm btn-markets"
              style="width: 100px;"
              @click="cancel"
            >
              CANCEL
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavbarComponent from "../../components/Navbar.vue";
import { apiService } from "../../_services";
import Editor from "@tinymce/tinymce-vue";
import router from "../../router";

export default {
  name: "CreateReport",
  components: {
    NavbarComponent,
    editor: Editor
  },
  data() {
    return {
      user: {},
      tags: {},
      listTagsSelected: [],
      nameView: "CREATE REPORT",
      dataReport: {
        idReport: "",
        title: "",
        image: "",
        summary: "",
        state: "",
        report: "",
        idUser: "",
        borrador: null,
        SelectTags: []
      },
      liststate: [
        {
          id: "",
          name: ""
        }
      ],
      listTags: [
        {
          id: "",
          name: "",
          idParent: ""
        }
      ],

      ValidateTitle: false,
      ValidateImage: false,
      ValidateSummary: false,
      ValidateReportType: false,
      ValidateViewEdit: false,

      MessageTitle: "",
      MessageImage: "",
      MessageSummary: "",
      MessageReportType: "",

      reponseMessage: ""
    };
  },
  created() {
    // get all local data
    try {
      this.user = this.$store.state.user.all.items;
    } catch (error) {
      console.log(`Error user ${error}`);
    }
    document.title = "CreateReport | QS";
    this.getState();
  },
  watch: {},
  methods: {
    validateView: function() {
      var IdReport = this.$route.params.id;
      if (IdReport != null || IdReport != undefined) {
        this.ValidateViewEdit = true;
        this.nameView = "EDIT REPORT";
        apiService.editReport(IdReport).then(data => {
          if (data != null || data != undefined) {
            var response = JSON.parse(data);

            this.dataReport.idReport = response[0].IdReport;
            this.dataReport.title = response[0].title;
            this.dataReport.image = response[0].img;
            this.dataReport.summary = response[0].summary;
            this.dataReport.state = response[0].state;
            this.dataReport.report = response[0].text;
            this.dataReport.idUser = response[0].fk_id_author;
            this.dataReport.borrador = null;
            if (response[0].tags != "") {
              var arrayTags = response[0].tags.split(",");
              var idTag = "";
              this.listTags.map(tag => {
                idTag = tag.id.toString();
                if (arrayTags.indexOf(idTag) > -1) {
                  this.listTagsSelected.push({ id: tag.id, name: tag.name });
                }
              });
            }
          }
        });
      }
    },
    getTags: function() {
      apiService.listTags().then(data => {
        if (data != null || data != undefined) {
          var response = JSON.parse(data);
          this.listTags = response.map(resp => {
            return {
              id: resp.pk,
              name: resp.fields.tag_name,
              idParent: resp.fields.Id_tag_parent
            };
          });
        }
        this.validateView();
      });
    },
    getState: function() {
      apiService.listState().then(data => {
        if (data != null || data != undefined) {
          var response = JSON.parse(data);
          this.liststate = response.map(resp => {
            return {
              id: resp.PK_IdState,
              name: resp.state_name
            };
          });
        }
        this.getTags();
      });
    },
    getSelectTags: function(idSelectTag) {
      var validateTag = false;
      var IdParent = 0;
      this.listTags.map(tag => {
        if (tag.id == idSelectTag) {
          IdParent = tag.idParent;
          this.listTagsSelected.map(listag => {
            if (listag.id == idSelectTag) {
              validateTag = true;
            }
          });
          if (validateTag == false) {
            this.listTagsSelected.push({ id: tag.id, name: tag.name });
          }
        }
      });
      if (IdParent != 0) {
        this.getSelectTags(IdParent);
      }
    },
    select: function() {
      this.getSelectTags(this.tags);
    },
    remove: function() {
      var cont = 0;
      this.dataReport.SelectTags.map(SelecTag => {
        this.listTagsSelected.map(listTag => {
          if (SelecTag == listTag.id) {
            this.listTagsSelected.splice(cont, 1);
          }
          cont += 1;
        });
        cont = 0;
      });
    },
    cancel: function() {
      router.push("/AdminReport");
    },
    saveReport: function(origen) {
      if (origen) {
        if (this.dataReport.title == "") {
          this.ValidateTitle = true;
          this.MessageTitle =
            "This field is required if the report is to be published.";
        }
        if (this.dataReport.image == "") {
          this.ValidateImage = true;
          this.MessageImage =
            "This field is required if the report is to be published.";
        }
        if (this.dataReport.summary == "") {
          this.ValidateSummary = true;
          this.MessageSummary =
            "This field is required if the report is to be published.";
        }
        if (this.dataReport.state == "") {
          this.ValidateReportType = true;
          this.MessageReportType =
            "This field is required if the report is to be published.";
        }
        this.dataReport.borrador = false;
      } else {
        this.dataReport.borrador = true;
        this.ValidateReportType = this.ValidateImage = false;
        this.MessageReportType = this.MessageImage = "";

        if (this.dataReport.summary == "") {
          this.ValidateSummary = true;
          this.MessageSummary =
            "This field is required if the report is to be published.";
        }

        if (this.dataReport.title == "") {
          this.ValidateTitle = true;
          this.MessageTitle =
            "This field is required if the report is to be published.";
        }

        if (this.dataReport.image == "")
          this.dataReport.image =
            "https://static.wixstatic.com/media/69ded1_fba37764e81b42c9b82b0013f05f6cca~mv2.png/v1/fill/w_278,h_89,al_c,q_85,usm_0.66_1.00_0.01/logo%20symmetry_transparente%20blanco.webp";
        if (this.dataReport.report == "")
          this.dataReport.report = "Report Draft";
      }
      this.dataReport.SelectTags = this.listTagsSelected;
      this.dataReport.idUser = this.user.pk_idusers;

      if (
        this.ValidateReportType == false &&
        this.ValidateSummary == false &&
        this.ValidateImage == false &&
        this.ValidateTitle == false
      ) {
        if (this.ValidateViewEdit == false) {
          apiService.saveReportBlog(this.dataReport).then(data => {
            this.reponseMessage = data;
            setTimeout(function() {
              router.push("/AdminReport");
            }, 2000);
          });
        } else {
          apiService.editReportBlog(this.dataReport).then(data => {
            this.reponseMessage = data;
            setTimeout(function() {
              router.push("/AdminReport");
            }, 2000);
          });
        }
      }
    }
  }
};
</script>
